import { AutogenModelEdiStatusCodeLookup, AutogenRowEdiStatusCodeLookup } from "./autogen/AutogenModelEdiStatusCodeLookup";

export class ModelEdiStatusCodeLookup extends AutogenModelEdiStatusCodeLookup<RowEdiStatusCodeLookup> {
	constructor() {
		super(RowEdiStatusCodeLookup);
	}
}

export class RowEdiStatusCodeLookup extends AutogenRowEdiStatusCodeLookup {
}